import { object, mixed } from 'yup';

import Step from './Step2';

export default {
  title: 'DFSU',
  component: Step,
  validationSchema: () =>
    object().shape({
      dfsu: object().shape({
        file: mixed()
          .required()
          .test(
            'fileFormat',
            'Unsupported Format',
            value => value && value.includes('dfsu')
          ),
      }),
    }),
};
